import { render, staticRenderFns } from "./vr-upload.vue?vue&type=template&id=36b8ef0a&scoped=true"
import script from "./vr-upload.vue?vue&type=script&lang=js"
export * from "./vr-upload.vue?vue&type=script&lang=js"
import style0 from "./vr-upload.vue?vue&type=style&index=0&id=36b8ef0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b8ef0a",
  null
  
)

export default component.exports